export default `<!DOCTYPE html>
<html lang="zh-CN">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1.0" />
    <title>签章</title>
    <style>
      #iframe {
        width: 100vw;
        height: 100vh;
      }
    </style>
  </head>
  <body>
    <iframe src="" frameborder="0" id="iframe" width="100%" height="100%"></iframe>
    <script>
      window.addEventListener(
        "message",
        (event) => {
          if(event.data.action === "SIGN_OPENED") {
              document.getElementById("iframe").src = event.data.data.signUrl;
              return;
          }
          const data = JSON.parse(event.data);
          if (data.action === "SIGN_COMPLETE_SIGN") {
            if (window.opener) {
              window.opener.postMessage(
                event.data,
                window.opener.location.origin
              );
            }
          }
        },
        false
      );
    </script>
  </body>
</html>`